module.exports = __webpack_public_path__ + "static/media/bg_video.2c2ba60.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/video/bg_video.mp4
// module id = FWAo
// module chunks = 209